module.exports = __webpack_public_path__ + "media/assets/svgs/arrow-white-760b4bf9b4e66db8c973c494696abd44.svg";